import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceNavigationService {
  private static allowNavigation = false;

  private readonly router = inject(Router);

  public setMaintenanceNavigationAllowed(): void {
    MaintenanceNavigationService.allowNavigation = true;
  }

  public isMaintenanceNavigationAllowed(): boolean {
    const allowed = MaintenanceNavigationService.allowNavigation;
    MaintenanceNavigationService.allowNavigation = false;

    return allowed;
  }

  public navigateToMaintenance(): void {
    this.setMaintenanceNavigationAllowed();
    this.router.navigate(['/maintenance'], { replaceUrl: true });
  }
}
